import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5b826b6ed3df7cd40ccb353a0407dff7.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-navy-950/85"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-10 text-center">
        <p className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4">Prêt à démarrer ?</p>
        <h2 className="font-heading font-bold text-white text-3xl md:text-4xl leading-tight mb-6">
          Contactez-nous pour<br />discuter de votre projet
        </h2>
        <p className="text-white/60 text-lg leading-relaxed mb-10">
          Que vous soyez une entreprise ou un particulier, CICHORZ vous accompagne dans la réalisation de vos projets informatiques à Paris.
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center gap-3 bg-white text-navy-900 font-semibold px-8 py-4 rounded-full hover:bg-gray-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-mail-send-line text-lg"></i>
          </div>
          Envoyer un message
          <i className="ri-arrow-right-up-line"></i>
        </Link>
      </div>
    </section>
  );
}
